import { normalize } from 'normalizr';
import { bandsSchema } from '../../../utils/normalizr/bandsSchema';
import {
  SELECTOR_OPTIONS_GET_REQUEST,
  SELECTOR_OPTIONS_GET_SUCCESS,
  SELECTOR_OPTIONS_GET_FAILURE,
} from '../../../actions/constants/types';

const initialState = {
  isFetching: false,
  entities: {},
};

function general(state = initialState, action) {
  if (action.reduxIdentifier !== 'bands') {
    return state;
  }

  switch (action.type) {
    case SELECTOR_OPTIONS_GET_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case SELECTOR_OPTIONS_GET_SUCCESS: {
      const normalizeResult = normalize(action.response.data.options, [bandsSchema]);
      return {
        entities: {
          ...normalize(action.response.data.options, [bandsSchema]).entities.bands,
          highestBand: normalizeResult.result.sort((a, b) => b - a)[0],
        },
        isFetching: false,
      };
    }
    case SELECTOR_OPTIONS_GET_FAILURE:
      return initialState;
    default:
      return state;
  }
}

export default general;
